import type {TranslationFunction} from 'src/types/language-support';
import type {IIdentificationMachineSnapshot} from '../machines/identificationMachine/identificationMachine';
import type {IParticipantType} from '../types/IParticipantType';


export const selectIsReschedule = (state: IIdentificationMachineSnapshot) => {
  return state.context.linkType === 'reschedule';
};

export const selectRescheduleReason = (
  state: IIdentificationMachineSnapshot,
) => {
  return state.context.reason;
};

export const selectTitle = (state: IIdentificationMachineSnapshot) => {
  return state.context.linkType === 'reschedule'
    ? 'Reschedule Meeting'
    : 'Cancel Meeting';
};

export const selectSuccessText = (
  state: IIdentificationMachineSnapshot,
  t: TranslationFunction,
  participantType?: IParticipantType,
) => {
  return state.context.linkType === 'reschedule'
    ? participantType === 'CANDIDATE'
      ? t(
          'The_link_to_reschedule_the_meeting_has_been_sent_to_the_candidate',
          'The link to reschedule the meeting has been sent to the candidate',
        )
      : t(
          'Reschedule_Link_has_been_sent_to_the_candidate',
          'Reschedule Link has been sent to the candidate',
        )
    : t(
        'Cancel_Link_has_been_sent_to_your_email',
        'Cancel Link has been sent to your email',
      );
};

export const selectButtonText = (
  state: IIdentificationMachineSnapshot,
  t: TranslationFunction,
  participantType?: IParticipantType,
) => {
  return state.context.linkType === 'reschedule'
    ? participantType === 'CANDIDATE'
      ? t('Email_me_reschedule_link', 'Email me reschedule link')
      : t('Request_reschedule_link', 'Request reschedule link')
    : t('Email_me_cancellation_link', 'Email me cancellation link');
};

export const selectErrorText = (
  state: IIdentificationMachineSnapshot,
  t: TranslationFunction,
) => {
  const errorData = state.context.error?.response?.data;
  if (!errorData) {
    return '';
  }
  const {errors, data} = errorData;
  const [firstError] = errors || [];

  let errorText =
    firstError === 'EventLinkAlreadyRequested'
      ? t('An_email_has_already_been_sent', 'An email has already been sent')
      : t('Event_is_in_the_past', 'Event is in the past');

  if (data?.ttl) {
    const ttl = data.ttl;
    const hours = Math.floor(ttl / 3600);
    const minutes = Math.floor((ttl % 3600) / 60);
    const timeString =
      hours > 0
        ? `${hours} ${hours === 1 ? t('hour', 'hour') : t('hours', 'hours')}`
        : `${minutes} ${
            minutes === 1 ? t('minute', 'minute') : t('minutes', 'minutes')
          }`;
    errorText += `, ${t('You_can_request_again_after_timeString', {
      timeString,
    })}.`;
  }
  return errorText;
};
